import ko from 'knockout'
import ObservableSubstitutePool from '../../../Model/Observables/ObservableSubstitutePool'

export class SubstitutesViewModel {
  public availableSubstitutePools: ko.ObservableArray<ObservableSubstitutePool>
  public isExpanded: ko.Observable<boolean>

  constructor(params: { availableSubstitutePools: ko.ObservableArray<ObservableSubstitutePool> }) {
    this.availableSubstitutePools = params.availableSubstitutePools
    this.isExpanded = ko.observable(false)
  }

  public toggleExpanded(): void {
    this.isExpanded(!this.isExpanded())
  }
}
